export function getImageBorderRadius(
  landing: boolean | undefined,
  isBrief: boolean | undefined,
) {
  if (landing) return 0;
  return isBrief ? 0 : '12px';
}

export function getContentPadding(
  landing: boolean | undefined,
  isBrief: boolean | undefined,
) {
  if (isBrief) return landing ? '16px 20px !important' : '0 16px !important';
  return landing ? '20px !important' : '12px 0 !important';
}
